import React from 'react';
import Icon from '../AppIcon';

const CheckoutProgress = ({ currentStep = 1, onStepClick = null }) => {
  const steps = [
    { id: 1, label: 'Cart Review', icon: 'ShoppingCart' },
    { id: 2, label: 'Shipping', icon: 'Truck' },
    { id: 3, label: 'Payment', icon: 'CreditCard' },
    { id: 4, label: 'Confirmation', icon: 'CheckCircle' }
  ];

  const getStepStatus = (stepId) => {
    if (stepId < currentStep) return 'completed';
    if (stepId === currentStep) return 'current';
    return 'upcoming';
  };

  const getStepClasses = (status) => {
    switch (status) {
      case 'completed':
        return 'bg-success text-success-foreground border-success';
      case 'current':
        return 'bg-primary text-primary-foreground border-primary';
      case 'upcoming':
        return 'bg-background text-text-secondary border-border';
      default:
        return 'bg-background text-text-secondary border-border';
    }
  };

  const getConnectorClasses = (stepId) => {
    return stepId < currentStep ? 'bg-success' : 'bg-border';
  };

  return (
    <div className="w-full py-6">
      {/* Desktop Progress */}
      <div className="hidden md:flex items-center justify-between max-w-2xl mx-auto">
        {steps.map((step, index) => {
          const status = getStepStatus(step.id);
          const isClickable = onStepClick && step.id <= currentStep;
          
          return (
            <React.Fragment key={step.id}>
              <div className="flex flex-col items-center">
                <button
                  onClick={isClickable ? () => onStepClick(step.id) : undefined}
                  disabled={!isClickable}
                  className={`
                    w-12 h-12 rounded-full border-2 flex items-center justify-center transition-smooth
                    ${getStepClasses(status)}
                    ${isClickable ? 'cursor-pointer hover:scale-105' : 'cursor-default'}
                  `}
                >
                  <Icon name={step.icon} size={20} />
                </button>
                <span className={`
                  mt-2 text-sm font-body-semibold
                  ${status === 'current' ? 'text-primary' : 
                    status === 'completed' ? 'text-success' : 'text-text-secondary'}
                `}>
                  {step.label}
                </span>
              </div>
              
              {index < steps.length - 1 && (
                <div className="flex-1 mx-4">
                  <div className={`
                    h-0.5 transition-smooth
                    ${getConnectorClasses(step.id)}
                  `} />
                </div>
              )}
            </React.Fragment>
          );
        })}
      </div>

      {/* Mobile Progress */}
      <div className="md:hidden">
        <div className="flex items-center justify-center space-x-2 mb-4">
          <span className="font-data font-data-medium text-sm text-text-secondary">
            Step {currentStep} of {steps.length}
          </span>
        </div>
        
        <div className="flex items-center space-x-2 mb-4">
          {steps.map((step) => {
            const status = getStepStatus(step.id);
            return (
              <div
                key={step.id}
                className={`
                  flex-1 h-2 rounded-full transition-smooth
                  ${status === 'completed' ? 'bg-success' :
                    status === 'current' ? 'bg-primary' : 'bg-border'}
                `}
              />
            );
          })}
        </div>
        
        <div className="text-center">
          <div className={`
            inline-flex items-center space-x-2 px-4 py-2 rounded-card
            ${getStepClasses(getStepStatus(currentStep))}
          `}>
            <Icon name={steps[currentStep - 1].icon} size={20} />
            <span className="font-body-semibold">
              {steps[currentStep - 1].label}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CheckoutProgress;